import clsx from 'clsx'
import React from 'react'
import { createPortal } from 'react-dom'

import { Icon } from '../Icon/Icon'

import './Modal.scss'

interface ModalProps {
  isOpen: boolean
  closeButtonType?: 'close' | 'back'
  onClose: () => void
  children: React.ReactNode
  header?: React.ReactNode
  classes?: string[]
}

export const Modal: React.FC<ModalProps> = ({
  isOpen,
  closeButtonType = 'close',
  onClose,
  children,
  header,
  classes,
}) => {
  const closeModal = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    onClose()
  }

  const closeButtonClasses = [
    'modal__close-button',
    closeButtonType === 'back' && 'modal__close-button--back',
  ]

  const modalContent = (
    <div
      className={clsx([
        'modal',
        isOpen && 'modal--open',
        classes ? classes : [],
      ])}
      role="dialog"
      aria-modal="true"
    >
      <button
        aria-label="Close Modal"
        className="modal__overlay"
        onClick={closeModal}
      />
      <header className="modal__close-header">
        {header}
        <button
          className={clsx(closeButtonClasses)}
          aria-label="Close Modal"
          onClick={closeModal}
          name="Close Modal"
        >
          <Icon name={closeButtonType === 'back' ? 'triangle' : 'cross'} />
        </button>
      </header>
      <section className="modal__content-container">{children}</section>
    </div>
  )

  return isOpen
    ? typeof document !== 'undefined' &&
        createPortal(modalContent, document.body)
    : null
}
